import { useState, useEffect } from 'react';

const useGetSubCataloguesWithAllItem = (subCatalogueId) => {
    const [subGroupedAllData, setSubGroupedAllData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSubCatalogueItemData = async () => {
            try {
                const response = await fetch( `https://backend.nuhababy.com/getSubCataloguesWithAllItem/${subCatalogueId}`);

                if (!response.ok) {
                    throw new Error('Failed to fetch grouped sub catalogue data');
                }

                const result = await response.json();
                console.log("getSubCataloguesWithAllItem", result.data)
                setSubGroupedAllData(result.data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSubCatalogueItemData();
    }, [subCatalogueId]);

    return { subGroupedAllData, loading, error };
};

export default useGetSubCataloguesWithAllItem;